import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import { displayDate } from '../../services/dates/dateService';
import * as periodosService from '../../services/periodos/periodosService';
import { classifyPeriodosError } from '../../services/periodos/periodosDto';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

export class MDPeriodoExamen extends Component {
  static displayName = MDPeriodoExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: 10,
      paginationData: [],
      pageCount: 0,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => periodosService.listPeriodoExamen(query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    this.searchInputRef = React.createRef();
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
    });
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWPeriodoExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handlePeriodosError(error));
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.grid.getState().search.trim() !== '') {
      this.grid.clearSearchIfNeeded(this.grid.getState().search).catch((error) => this.handlePeriodosError(error));
    }
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.grid.submitSearch(search).catch((error) => this.handlePeriodosError(error));
  };

  handleRemoveItem = (periodo) => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({
      pendingDelete: {
        id: periodo.peridoExamenCod,
        nombre: periodo.periodoExamenDescripcion,
        detalle: `${periodo.anioAcademicoDescripcion} — Llamado ${periodo.periodoExamenLlamado}`,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || this.state.deletingId) {
      return;
    }
    this.deleteItem(pendingDelete.id);
  };

  renderTable(periodos) {
    return (
      <div className="md-page__table-card md-pex__table-card">
        <div className="md-pex__table-scroll">
          <table className="md-page__table md-page__table--pex-grid" aria-labelledby="md-pex-title">
            <colgroup>
              <col style={{ width: '18%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '11%' }} />
              <col style={{ width: '11%' }} />
              <col style={{ width: '8%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">Período</th>
                <th scope="col" className="md-page__table__col-llamado">Llamado</th>
                <th scope="col">Año académico</th>
                <th scope="col" className="md-page__table__col-fecha-inicio">
                  Fecha
                  <br />
                  de inicio
                </th>
                <th scope="col" className="md-page__table__col-fecha-fin">
                  Fecha
                  <br />
                  de fin
                </th>
                <th scope="col" className="md-page__table__actions-header md-page__table__col-actions" aria-label="Acciones" />
              </tr>
            </thead>
            <tbody>
              {periodos.map((periodo) => {
                const id = periodo.peridoExamenCod;
                return (
                  <tr key={id}>
                    <MdTableCell>{periodo.periodoExamenDescripcion}</MdTableCell>
                    <MdTableCell className="md-page__table__col-llamado">{periodo.periodoExamenLlamado}</MdTableCell>
                    <MdTableCell>{periodo.anioAcademicoDescripcion}</MdTableCell>
                    <MdTableCell className="md-page__table__col-fecha-inicio">
                      {displayDate(periodo.periodoExamenFechaInicio)}
                    </MdTableCell>
                    <MdTableCell className="md-page__table__col-fecha-fin">
                      {displayDate(periodo.periodoExamenFechaFin)}
                    </MdTableCell>
                    <MdTableActionsCell>
                      <MdRowActions
                        items={buildStandardRowActions({
                          editTo: `/update-pex/${id}/0`,
                          onDelete: () => this.handleRemoveItem(periodo),
                          deleteDisabled: this.state.loading || this.state.deletingId === id,
                          deleteLabel: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
                          detailTo: `/update-pex/${id}/1`,
                        })}
                      />
                    </MdTableActionsCell>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-pex">
        <div className="md-page__header">
          <h1 id="md-pex-title" className="md-page__title">Manejar Datos de Períodos de Examen</h1>
        </div>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        {!this.state.showErrorMessage ? (
          <>
            <div className="md-page__toolbar">
              <Link className="md-page__action-link" to="/add-pex">
                <PlusIcon />
                Nuevo período de examen
              </Link>
            </div>

            <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
              <div className="md-page__search-wrap">
                <span className="md-page__search-icon">
                  <SearchIcon />
                </span>
                <input
                  ref={this.searchInputRef}
                  className="md-page__search-input"
                  type="text"
                  name="search"
                  autoComplete="off"
                  disabled={isBusy}
                  placeholder="Ingrese año académico, período o llamado"
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputChange}
                />
              </div>
              <button type="submit" className="md-page__search-btn" disabled={isBusy}>
                Buscar
              </button>
            </form>

            {contents}

            {!listLoading && this.state.pageCount > 1 ? (
              <div className="md-page__pagination">
                <ReactPaginate
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  forcePage={this.state.forcePage}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                />
              </div>
            ) : null}
          </>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar período de examen"
          message="Esta acción eliminará el registro y no se puede deshacer."
          detail={pendingDelete ? `${pendingDelete.nombre} — ${pendingDelete.detalle}` : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  handlePeriodosError(error) {
    const outcome = classifyPeriodosError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handlePeriodosError(error);
    }
  }

  async deleteItem(id) {
    this.setState({ deletingId: id, showErrorMessage: false, errorMessage: '' });
    try {
      await periodosService.deletePeriodoExamen(id);
      this.setState({ successMessage: 'El registro se eliminó correctamente.', pendingDelete: null });
      await this.grid.reloadAfterDelete(this.state.paginationData.length);
    } catch (error) {
      this.handlePeriodosError(error);
    } finally {
      this.setState({ deletingId: null });
    }
  }
}
